import React from 'react';
import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import NavigateAction from './NavigateAction';

const NavigateActionPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.navigate.name]: (<NavigateAction relationship={resource.relationship(fr.relationships.navigate.name)} />),
  }, null);
};

NavigateActionPicker.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default NavigateActionPicker;
